import { httpClient, ApiResponse } from '@/utils';
import {
  CancelledOrdersEndpoints,
  ICancelledOrdersListQuery,
  ICancelledOrdersQuery,
  IGetCancelledOrdersResponse,
  IGetCancelledPartnersResponse,
  IGetCancelledReasonsResponse,
} from '@/models/cancelledOrders.model';

class CancelledOrdersAPI {
  static getCancelledOrders(params: ICancelledOrdersQuery): ApiResponse<IGetCancelledOrdersResponse> {
    return httpClient.get<IGetCancelledOrdersResponse>(CancelledOrdersEndpoints.CANCELLED_ORDERS, { params });
  }

  static getCancelledReasons(params: ICancelledOrdersListQuery): ApiResponse<IGetCancelledReasonsResponse> {
    return httpClient.get<IGetCancelledReasonsResponse>(CancelledOrdersEndpoints.CANCELLED_ORDERS_REASONS, { params });
  }

  static getCancelledPartners(params: ICancelledOrdersListQuery): ApiResponse<IGetCancelledPartnersResponse> {
    return httpClient.get<IGetCancelledPartnersResponse>(CancelledOrdersEndpoints.CANCELLED_ORDERS_PARTNERS, {
      params,
    });
  }
}

export default CancelledOrdersAPI;
